/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Themedark1Inputs */

const zh_user_themedark1 = /** @type {(inputs: User_Themedark1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`深色`)
};

const en_user_themedark1 = /** @type {(inputs: User_Themedark1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dark`)
};

const es_user_themedark1 = /** @type {(inputs: User_Themedark1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oscuro`)
};

/**
* | output |
* | --- |
* | "Dark" |
*
* @param {User_Themedark1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const user_themedark1 = /** @type {((inputs?: User_Themedark1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Themedark1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_user_themedark1(inputs)
	if (locale === "en") return en_user_themedark1(inputs)
	return es_user_themedark1(inputs)
});
export { user_themedark1 as "user_themeDark" }